import React, { createContext } from "react";

export interface BoardTemplatesModalContextValue {
  selectedCategory: string;
  selectedTemplate: string | null;
  isCreatingBoardInProgress: boolean;
  searchQuery: string;
  searchInputProps: {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
  resetSearchQuery: () => void;
  handleUseTemplate: (templateId: string) => void;
  setSelectedCategory: (category: string) => void;
  setSelectedTemplate: (template: string | null) => void;
}

export const BoardTemplatesModalContext =
  createContext<BoardTemplatesModalContextValue | null>(null);
